module.exports = __webpack_public_path__ + "static/media/credit_card_all.67a65bd6.png";